module.exports = function isArray(x) {
  return x instanceof Array;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb/lib/isArray.js
 ** module id = 487
 ** module chunks = 1
 **/